import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './styles.styl';
import current from '../../assets/images/global-current.svg';
import check from '../../assets/images/global-checkmark.svg';
import caret from '../../assets/images/global-caret-up.svg';

const mapStateToProps = state => ({
  completed: state.task.completed,
  pathState: state.path
});

const MenuPage = ({
  completed,
  path,
  title,
  location,
  currentPage,
  pathState,
  allPathsOn
}) => {
  const isCompleted = completed.includes(path);

  const getLinkClasses = path => {
    return classNames('menu__page__link', {
      'menu__page__link--completed': isCompleted,
      'menu__page__link--disabled': isLinkInactive(path)
    });
  };

  const isLinkInactive = newPath => {
    // if the newPath is not the farthest path,
    // and if the newPath isn't in completed
    // and we don't have allPathsOn: link is styled as inactive
    return (
      newPath !== pathState.farthestPath &&
      !completed.includes(newPath) &&
      allPathsOn === false
    );
  };

  const renderLinks = (path, title) => {
    if (isLinkInactive(path)) {
      return <span className={getLinkClasses(path)}>{title}</span>;
    } else {
      return (
        <NavLink
          to={path}
          className={getLinkClasses(path)}
          activeClassName={'menu__page__link--current-page'}
        >
          {title}
        </NavLink>
      );
    }
  };

  const renderPageIcons = path => {
    if (path === pathState.farthestPath) {
      return <img src={current} alt="" />;
    } else if (path === currentPage) {
      return <img className="menu-page__icon__rotate" src={caret} alt="" />;
    } else if (isCompleted) {
      return <img src={check} alt="" />;
    }
  };

  if (path) {
    return (
      <li className="menu__page">
        <span className="menu-page__icon">{renderPageIcons(path)}</span>
        {renderLinks(path, title)}
      </li>
    );
  } else {
    return (
      <li className="menu__page">
        <div>{title}</div>
      </li>
    );
  }
};

MenuPage.propTypes = {
  completed: PropTypes.array.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(MenuPage);



// WEBPACK FOOTER //
// ../core/src/components/Menu/MenuPage.js